<div class="container" #formDialog>
    <div class="row header">
        <div mat-dialog-title class="col-md-10">
            <div *ngIf="showPopupTitle">{{popupTitle | translate}}</div>
            <div *ngIf="clickedOutside && showAlert" class="d-flex">
                <asp-icon name="ic-20-feedback-alert-error.svg" width="1rem" ></asp-icon>
                <h6 class="alert-msg">{{'otherTexts.pleaseSelectYesOrNo'| translate}}</h6>
              </div>
        </div>
        <div class="col-md-2 icon" (click)="closeWindow()">
            <asp-icon name="ic-20-utility-close-default.svg"></asp-icon>
        </div>
    </div>
</div>
<div class="container-fluid">
    <div class="row">
        <div class="col-md-12" *ngIf="popupBodyText.trim()">
            <div class="body-text" [innerHTML] = "popupBodyText | translate">
            </div>
        </div>
        <div class="col-md-12" *ngIf="data?.key === 'save'">
            <div class="body-text">
               <!-- insert datepicker  here-->
               <div class="pl-5 date-label">{{'appointmentPrint.date' | translate | titlecase}}</div>
               <mat-form-field appearance="outline" >
                
                <input matInput [matDatepicker]="picker" [(ngModel)]="selectedDate" (ngModelChange)="checkDate()" (click)="picker.open()" [placeholder]="'departmentHolidays.chooseDate' | translate"/>
                <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
                <mat-datepicker #picker></mat-datepicker>
              </mat-form-field>
              <div *ngIf="errorText" style="color: red;">{{errorText}}</div>
            </div>
        </div>
        <div class="col-md-12" *ngIf="data?.key === 'email'">
            <div class="body-text">
                <mat-form-field appearance="outline" class="email-input-field">
                    <input matInput [formControl]="emailControl" />
                </mat-form-field>
                <div *ngIf="shouldShowEmailError()" class="error-text">{{ 'deliveryChecklist.pleaseEnterValidEmailAddress' | translate }}</div>
            </div>
        </div>
    </div>
    <div class="row">
        <div class="col-md-12">
            <div class="action-con">
                <div (click)="confirm('ok')" *ngIf="!(data?.options)|| (data.options?.length ===0 )">
                    <button  class="action-ok-btn" [disabled]="isConfirmDisabled()">
                        <span>{{ okButton | translate }}</span>
                    </button>
                </div>
                <ng-container *ngIf="data?.key==='delete'">
                    <div (click)="confirm(option)" *ngFor="let option of data.options">
                        <button  class="action-ok-btn">
                            <span>{{getTranslation(option)}}</span>
                        </button>
                    </div>
                </ng-container> 
                <div (click)="close()" *ngIf="showCancelButton">
                    <button  class="action-cancel-btn">
                        <span>{{ cancelButton | translate }}</span>
                    </button>
                </div>
            </div>
        </div>
    </div>
</div>
